class ServiceBase {

}

export default ServiceBase;